import React, { Component } from "react";
import moment from "moment";
import {
  Row,
  Col,
  Table,
  Pagination,
  Switch,
  Select,
  Tooltip,
  Button,
  Icon
} from "antd";
import debounce from "lodash/debounce";
import CopyToClipboard from "react-copy-to-clipboard";
import { strings } from "../../helpers";

const { Option } = Select;

const status = [
  {
    id: "NEW",
    name: "NEW"
  },
  {
    id: "COMPLETED",
    name: "COMPLETED"
  },
  {
    id: "CANCELLED",
    name: "CANCELLED"
  }
];

class AdCampaignView extends Component {
  render() {
    const {
      adCampaigns,
      allRecords,
      pageNo,
      perPage,
      onPageChange,
      handleChangePageSizeChange,
      handleViewDescription,
      handleToggleActivation,
      clinics,
      fetchClinicsList,
      handleSelectClinic,
      handleChangeStatus,
      handleEditCampaign,
      handleLinkCopyClick
    } = this.props;

    const columns = [
      {
        title: "",
        key: "active_status",
        width: 60,
        render: record => {
          return (
            <Switch
              checked={record.attributes.active}
              onChange={value => handleToggleActivation(value, record)}
              size="small"
            />
          );
        }
      },
      {
        title: "Name",
        key: "attributes.campaign_name",
        width: 120,
        align: "left",
        render: record => {
          return (
            <Tooltip title="View Leads">
              <a href={`/campaign-leads?clid=${record.attributes.id}`}>
                {record.attributes.campaign_name}
                <div>
                  {record.attributes.campaign_leads_count
                    ? `(${record.attributes.campaign_leads_count} leads)`
                    : " - (0 leads)"}
                </div>
              </a>
            </Tooltip>
          );
        }
      },
      {
        title: "Clinic",
        align: "left",
        key: "clinic_name",
        width: 140,
        render: record => {
          return (
            <div>
              <b>{record.attributes.clinic_name}</b>
              <div>
                <b>Clinic no.:</b> {record.attributes.user_phone_number}
              </div>
              <div>
                <b>Contact no.</b>
                {`+${record.attributes.contact_country_code}-${record.attributes.contact_phone_number}`}
              </div>
            </div>
          );
        }
      },
      {
        title: "Landing page",
        key: "landing_path",
        align: "left",
        width: 150,
        render: record => {
          return (
            <>
              <a href={record.attributes.page_url} target="_blank">
                {`${record.attributes.page_url}`}
              </a>
              <div>
                <CopyToClipboard
                  text={`${record.attributes.page_url}?utm_source=facebook`}
                >
                  <Tooltip title="Click to copy link for facebook">
                    <a href="#" onClick={handleLinkCopyClick}>
                      <Icon type="facebook" className="font-size-18" />
                    </a>
                  </Tooltip>
                </CopyToClipboard>
                <CopyToClipboard text={`${record.page_url}?utm_source=google`}>
                  <Tooltip title="Click to copy link for google">
                    <a href="#" onClick={handleLinkCopyClick}>
                      <Icon type="google" className="font-size-18 ml-5" />
                    </a>
                  </Tooltip>
                </CopyToClipboard>
              </div>
            </>
          );
        }
      },
      {
        title: "Status",
        key: "campaign_status",
        render: record => (
          <div className="d-flex vertical-align-center">
            <Select
              style={{ width: 120 }}
              onChange={val => handleChangeStatus(val, record)}
              placeholder="Select"
              value={record.attributes.campaign_status}
            >
              {status.length > 0 &&
                status.map(obj => {
                  return <Option key={obj?.id}>{obj?.name}</Option>;
                })}
            </Select>
          </div>
        )
      },
      {
        title: "Description",
        key: "description",
        render: record => {
          return (
            <a href="" onClick={e => handleViewDescription(e, record)}>
              View description
            </a>
          );
        }
      },
      {
        title: "Date",
        key: "date",
        render: record => {
          return (
            <div>
              {record.attributes.start_time
                ? moment(record.attributes.start_time).format("DD MMM YYYY")
                : ""}{" "}
              -{" "}
              {record.attributes.end_time
                ? moment(record.attributes.end_time).format("DD MMM YYYY")
                : ""}
            </div>
          );
        }
      },
      {
        align: "left",
        render: record => (
          <div>
            {
              <Tooltip title="Click to edit">
                <Button
                  type="default"
                  shape="circle"
                  icon="edit"
                  className="mr-10"
                  onClick={() => handleEditCampaign(record)}
                />
              </Tooltip>
            }
          </div>
        )
      }
    ];
    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row>
            <Col className="heading-domain pl-0">Ad Campaigns</Col>
          </Row>
          <Row className="mb-10">
            <Col span={6}>
              <label>Select clinic:</label>
              <Select
                className="full-width"
                showSearch
                filterOption={false}
                onSearch={debounce(fetchClinicsList, 800)}
                onChange={handleSelectClinic}
                allowClear
              >
                {clinics.map((clinic, index) => (
                  <Option key={index} value={clinic.id}>
                    {clinic.name}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>

          <Table
            pagination={false}
            dataSource={adCampaigns}
            columns={columns}
          />

          <div className="pagination-wrapper">
            <div className="total-results-wrap">
              <span className="result-count">{allRecords}</span>
              {allRecords > 1 ? strings.results : strings.result}
            </div>
            {allRecords > 10 && (
              <Pagination
                total={allRecords}
                current={pageNo}
                onChange={onPageChange}
                pageSize={perPage}
                defaultCurrent={pageNo}
                showSizeChanger
                showQuickJumper
                onShowSizeChange={handleChangePageSizeChange}
                pageSizeOptions={[
                  "10",
                  "50",
                  "100",
                  "150",
                  "200",
                  "250",
                  "300",
                  "350",
                  "400",
                  "450",
                  "500"
                ]}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default AdCampaignView;
